// extracted by mini-css-extract-plugin
module.exports = {"mainTable":"Static_mainTable__3Ll6U"};